import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../../helpers/reducerRegistry'
import { convertDataAlert, convertDataChart } from '../helper'
import { getTotalAlert } from './thunk'

const initialState = {
  dataTotalAlert: {},
  dataChart: [],
  loading: {
    totalAlert: true,
  },
}

const slice = createSlice({
  name: 'dashboard/totalAlerts',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //getTotalAlert
    builder.addCase(getTotalAlert.pending, (state) => {
      state.loading.totalAlert = true
    })
    builder.addCase(getTotalAlert.fulfilled, (state, { payload = {} }) => {
      state.dataTotalAlert = convertDataAlert(payload)
      state.dataChart = convertDataChart(payload)
      state.loading.totalAlert = false
    })
    builder.addCase(getTotalAlert.rejected, (state, action) => {
      state.loading.totalAlert = action.payload.loading
    })
  },
})

export const loadingTotalAlert = (type) => (state) =>
  state[slice.name].loading[type]

export const dataTotalAlert = (state) => state[slice.name].dataTotalAlert
export const dataChartAlert = (state) => state[slice.name].dataChart

register(slice.name, slice.reducer)
